import type { Component, JSX } from 'solid-js'

type Props = {
  /** 全画面（シアター）モードでは画面いっぱいに広げる */
  theater?: boolean
  children?: JSX.Element
}

/**
 * YouTube Player を収める 16:9 のコンテナ。
 *
 * 高さは .player-box（src/index.css）で確定させている。
 * 高さが決まっていれば aspect-video から幅が決まるので、
 * 縦が足りない端末でもこの要素が他を押し出すことがない。
 *
 * 全画面では残りの領域をすべて使う。16:9 に収まらない画面でも
 * Player 側が映像をレターボックスで収めるので、黒地のまま広げてよい。
 */
export const PlayerFrame: Component<Props> = (props) => {
  return (
    <div
      class={
        props.theater
          ? 'min-h-0 w-full flex-1 overflow-hidden bg-black'
          : 'player-box mx-auto aspect-video max-w-full overflow-hidden bg-black sm:rounded-ch sm:border sm:border-ch-border'
      }
    >
      <div class="player-stage relative size-full">{props.children}</div>
    </div>
  )
}
